// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qVCG","left":"styles_left__giEPm"};